import { Pipe, PipeTransform } from '@angular/core';

/**
 * `currency` es opcional y por default 'cop' — preserva byte a byte el
 * comportamiento actual para los usos existentes (agendamiento, reportes,
 * historial de facturación) que NUNCA pasan este tercer parámetro y deben
 * seguir viéndose exactamente igual. Solo las suscripciones corporativas
 * (planes Pro/Max en USD) pasan 'usd' explícito.
 */
@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number | string | null | undefined, decimals = 0, currency: 'cop' | 'usd' = 'cop'): string {
    if (value == null || value === '') return '';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    const locale = currency === 'usd' ? 'en-US' : 'es-CO';
    return `$${num.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  }
}